<div
  class="ui info icon message text-center"
  *ngIf="isBanner"
  style="border-radius: 0px"
  appMargin
  marginB="0px"
>
  <!-- <i class="big info circle icon"></i> -->
  <div class="content">
    <span class="link">{{ bannerDesc }}</span>
    <button
      class="ui primary button"
      style="margin-left: 15px"
      (click)="showBanner()"
    >
      VIEW MESSAGE
    </button>
  </div>
</div>
<sui-sidebar-container>
  <sui-sidebar class="vertical inverted" id="bg" [isVisible]="false" #sidebar>
    <app-public-sidebar (onItemSelected)="sidebar.close()"></app-public-sidebar>
  </sui-sidebar>
  <sui-sidebar-sibling [isDimmedWhenVisible]="true">
    <div
      class="ui menu toolbar"
      [ngStyle.xs]="{ 'padding-left.em': 0, 'padding-right.em': 0 }"
      paddingX="10"
      appPadding
      marginB="0"
      appMargin
    >
      <div class="ui container">
        <div class="item header" id="no-borderline">
          <i
            *ngIf="media.isActive('xs')"
            class="sidebar large icon"
            style="color: #fff"
            (click)="sidebar.open()"
          ></i>
          <img class="ui image logo" src="./assets/images/logo.svg" />
        </div>
        <div class="right menu" *ngIf="!media.isActive('xs')">
          <a id="menu" (click)="triggerEvent()" routerLink="/home-page/sign-in">
            Sign In
          </a>

          <a id="menu-2" routerLink="/home-page/sign-up"> Create an Account </a>
        </div>
      </div>
    </div>

    <div class="bottom computer only" *ngIf="!media.isActive('xs')">
      <div class="ui container">
        <div class="ui pointing secondary menu">
          <a
            class="item"
            routerLink="/home-page/dashboard"
            routerLinkActive="active"
            style="padding-left: 0"
            >Home</a
          >
          <a class="item" routerLink="/home-page/pay" routerLinkActive="active"
            >Pay NCC</a
          >
          <a
            class="item"
            routerLink="/home-page/tender"
            routerLinkActive="active"
            >Tenders</a
          >
          <a class="item" routerLink="/home-page/faq" routerLinkActive="active"
            >FAQs</a
          >
          <a
            class="item"
            routerLink="/home-page/contact"
            routerLinkActive="active"
            >Contact</a
          >
        </div>
      </div>
    </div>
    <div class="scroll-wrapper">
      <div class="ui container">
        <div
          class="ui vertical basic segment"
          appMargin
          marginT="5"
          appMargin
          marginB="20"
        >
          <router-outlet></router-outlet>
        </div>

        <div class="ui divider"></div>
        <!-- Footer -->
        <div
          fxLayout="row"
          fxLayoutAlign="space-between"
          fxLayout.lt-sm="column"
          fxLayoutGap="15px"
          appMargin
          marginB="10"
        >
          <div fxFlex.lt-sm="100%">
            <div class="item">
              @ Nigeria Communications Commission {{ year }}. All Rights
              Reserved
            </div>
          </div>
          <div
            fxFlex.lt-sm="100%"
            style="display: flex; flex-direction: column; align-items: end"
          >
            <div>
              <a class="item" target="_blank" href="https://ncc.gov.ng/"
                >NCC Website</a
              >
              &nbsp;| &nbsp;
              <a class="item" [routerLink]="['/home-page/terms-and-conditions']"
                >Terms & Condition</a
              >
              &nbsp;
            </div>
            <div style="margin-top: 10px; margin-bottom: 45px">
              <img
                src="../../../assets/images/remita-payment-logo-horizonal.png"
                alt="ncc-logo"
                class="remita"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </sui-sidebar-sibling>
</sui-sidebar-container>
